import { render, staticRenderFns } from "./website_target_audiences.vue?vue&type=template&id=485cf5a1&scoped=true"
import script from "./website_target_audiences.vue?vue&type=script&lang=js"
export * from "./website_target_audiences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485cf5a1",
  null
  
)

export default component.exports